import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import style from './NonFaceFindId.module.css';
import URL from '../../../../constants/url';
import { useNavigate } from "react-router-dom";
import { sendAftcrEmailAuthNumber, verifyingEmailAuthNumber } from '../../../../assets/js/comm';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';


const NonFaceFindId = () => {

    const navigate = useNavigate();
    const onDismiss = () => setOpen(false);

    const [step, setStep] = useState(1);
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [patientCode, setPatientCode] = useState('');
    const [timeLeft, setTimeLeft] = useState(300); // 5분 = 300초
    const [isTimeout, setIsTimeout] = useState(false);
    // 토스트메시지 관련 세트
    const [overseasUser, setOverseasUser] = useState({});
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');


    //버튼 활성화 조건
    const isNextEnabled = () => {
        if (step === 1) {
            return patientCode.length > 0;
        }
        if (step === 2) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }
        if (step === 3) {
            return verificationCode.length > 0 && !isTimeout;
        }
        if (step === 4) {
            return true;
        }
        return false;
    };


    // 인증시간
    useEffect(() => {
        if (step >= 3 && timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else if (timeLeft === 0) {
            setIsTimeout(true);
        }
    }, [timeLeft, step]);

    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    //다음 버튼
    const handleNext = () => {

        if(step === 1) {
            // 환자번호 인증은 없으므로.. 그냥 2단계로 ...
            setStep(2);
        }
        if(step === 2) {
            console.log( " ==========> nonFace email : ", email );

            // 세밀한 이메일 형식 정규식 (대문자, 소문자, 숫자, -, _, . 모두 허용)
            const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

            if (!emailPattern.test(email)) {
                setToastMessage('Please check the email format.');
                setToast(true);
                return false;
            }

            if( email ) {
                const nonUserInfo = {
                    to: email
                }
                sendAftcrEmailAuthNumber(nonUserInfo); // 전송되든 안되든 중요하지가 않음.
                setToastMessage("A verification code has been \n sent to  your email.");
                setToast(true);
                setStep(3);
            } else {
                setToastMessage("Your email address is missing or not verified.\n Please enter it correctly.");
                setToast(true);
                return false;
            }

        }
        if (step === 3) {

            console.log( " ==========> nonFace email verificationCode : ", verificationCode );
            if( verificationCode ) {
                const nonUserInfo = {
                    to: email
                    , authNumber: verificationCode
                }
                verifyingEmailAuthNumber(nonUserInfo)
                    .then( async (res) => {
                        console.log(" ========> Email Verification Code res : " , res);

                        if( res?.resultCode === CODE.RCV_SUCCESS ) {
                            //setToastMessage("Email verification has been completed.");
                            //setToast(true);
                            setIsTimeout(true);
                            // 인증번호가 맞는 경우.. 회원조회 시도 로직 가동
                            await searchOverseasUserId()
                                .then( (resp) => {
                                    //console.log("============> searchOverseasUserId result : ", resp);
                                    if( resp?.resultCode === CODE.RCV_SUCCESS ) {
                                        const userInfo = resp.result.userInfo;
                                        setOverseasUser(userInfo);
                                        setStep(4);
                                    } else {
                                        setToastMessage("No matching patient information found. \nPlease check again.");
                                        setToast(true);
                                    }
                                })
                                .catch((err) => {
                                    console.log("==========> searchOverseasUserId Error : ", err);
                                })
                        } else {
                            setToastMessage("The Email Address and \nverification code does not match. \nPlease try again.");
                            setToast(true);
                        }
                    })
                    .catch( (err) => {
                        console.log(" =======> Email Verification Code Error : ", err );
                    })
            } else {
                setToastMessage("The verification number was not entered.. \nPlease check again.");
                setToast(true);
                return false;
            }
        }
        if( step === 4 ) {
            navigate(URL.NONFACE_LOGIN_MAIN);
        }
    };

    /**
     * 해외환자 사용자 아이디 조회 호출
     */
    const searchOverseasUserId = () => {

        const requestApiUrl = "/signup/retrieveOverseasPatientUserId";

        const requestBody = {
            cnncPatntNo: patientCode
            , emailAdres: email
        };

        return axiosApi.post(requestApiUrl, requestBody)
            .then( (res) => res.data )
            .catch(err => {
                console.error( err );
                throw err;
            });
    };

    //아이디 노출 처리
    const maskId = (id) => {
    if (id.length <= 3) {
        return id; // 3글자 이하라면 마스킹하지 않음
        }
        const visiblePart = id.slice(0, 3);
        const maskedPart = '*'.repeat(id.length - 3);
        return visiblePart + maskedPart;
    };

    //아이디 찾기 함수


    return (
        <>
            <HeadSub title="Find ID"/>

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">


                        <div className={style['content-box']}>
                            <strong className={style['title']}>
                                {step === 2 ? 'Please enter your email'
                                :step === 3 ? 'Please enter verification code'
                                    : step === 4 ? ''
                                    : 'Please enter your patient number'
                                }
                            </strong>


                        {step === 4 && (
                            <div className={style['mid-box']}>
                                <div className='animation-2'>
                                    <p className={style['top']}>
                                        <b>The ID matching <br />
                                            the entered information
                                        </b>
                                    </p>

                                    <div className={style['botm']}>
                                        <ul>
                                            <li>
                                                <p>ID</p>
                                                <span>{maskId(overseasUser?.usrId)}</span>
                                            </li>
                                            <li>
                                                <p>Sign-up Date</p>
                                                <span>{overseasUser?.signupDt}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}

                        { step >= 3 && step < 4 &&  (

                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Verification code</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="Enter verification code"
                                        value={verificationCode}
                                        onChange={(e) => setVerificationCode(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                    <button className={style['cancel-btn']} onClick={() => setVerificationCode('')}></button>
                                </div>
                                <div className={style['input-bottom']}>
                                    <span className={style['time']}>
                                        {isTimeout ? 'Authentication timeout' : formatTime(timeLeft)}
                                    </span>
                                    <button
                                        className={style['request-btn']}
                                        disabled={!(isTimeout || timeLeft < 240) }
                                        onClick={() => {
                                            setTimeLeft(300); // 타이머 초기화
                                            setIsTimeout(false);
                                            setVerificationCode('');
                                            const nonUserInfo = {
                                                to: email
                                            }
                                            sendAftcrEmailAuthNumber(nonUserInfo); // 전송되든 안되든 중요하지가 않음.
                                            setToastMessage("A verification code has been \n sent to  your email.");
                                            setToast(true);
                                        }}

                                    >
                                        <span>Resend</span>
                                    </button>
                                </div>
                                </div>
                            </div>
                        )}

                        {step >= 2 && step < 4 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Email</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="email"
                                        placeholder="aaaaa@email.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>

                        )}

                        {step >= 1 && step < 4 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Patient number</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="00000000"
                                        onChange={(e) => setPatientCode(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>

                        )}

                        </div>
                        {/* 아이디 비밀번호 입력 화면:: E */}



                        {/* 다음 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleNext}
                                    disabled={!isNextEnabled()}
                                >
                                    <span>
                                        {step >= 3 ? 'Confirm'
                                        :  'Next'
                                        }
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            position="center"
                            opacity="90"
                        />
                    )}


                    </div>
                </div>
        </>
    )
}

export default NonFaceFindId
